import { LuLaptop, LuSmartphone } from "react-icons/lu";
import { Badge, Button, Card, CardBody, Table, TabPane } from "reactstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { post } from "../../../../../utils/helpers/api";

const DeviceIcon = ({ user_agent }) =>
  /ios|android/i.test(user_agent) ? <LuSmartphone size={18} /> : <LuLaptop size={18} />;

const detectBrowser = (user_agent, t) => {
  if (/chrome/i.test(user_agent)) return 'Chrome';
  if (/firefox/i.test(user_agent)) return 'Firefox';
  if (/safari/i.test(user_agent)) return 'Safari';
  if (/edge/i.test(user_agent)) return 'Edge';
  if (/opera/i.test(user_agent)) return 'Opera';
  return t('security.unknownBrowser');
};

const detectDevice = (user_agent, t) => {
  if (/iphone|ipad|ipod/i.test(user_agent)) return 'iOS Device';
  if (/android/i.test(user_agent)) return 'Android Device';
  if (/windows phone/i.test(user_agent)) return 'Windows Phone';
  if (/macintosh/i.test(user_agent)) return 'Mac';
  if (/windows/i.test(user_agent)) return 'Windows PC';
  return t('security.unknownDevice');
};

const detectOS = (user_agent, t) => {
  if (/windows/i.test(user_agent)) return 'Windows';
  if (/macintosh/i.test(user_agent)) return 'macOS';
  if (/linux/i.test(user_agent)) return 'Linux';
  if (/android/i.test(user_agent)) return 'Android';
  if (/iphone|ipad|ipod/i.test(user_agent)) return 'iOS';
  return t('security.unknownOS');
};

const isCurrentSession = (user_agent) => {
  const currentUserAgent = navigator.userAgent;
  return user_agent === currentUserAgent;
}

function SessionsTab({ activeDevices, refreshData }) {
  const { t } = useTranslation();

  const revokeSession = async (sessionId) => {
    const data = await post('/settings/security/sessions/revoke', {
      id: sessionId
    });
    if (data?.success) {
      toast.success(t('security.sessionRevoked'));
      refreshData();
    } else {
      toast.error(t('security.sessionRevokeFailed'));
    }
  }

  return(
    <TabPane tabId="sessions">
      <Card className="mb-3">
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="text-muted small fw-semibold text-uppercase mb-0">{t('security.activeSessions')}</p>
          </div>
          {activeDevices.map((s, i) => (
            <div key={s.id} className={`d-flex align-items-center justify-content-between py-3 ${i < activeDevices.length - 1 ? 'border-bottom' : ''}`}>
              <div className="d-flex align-items-center gap-3">
                <div className="text-muted">
                  <DeviceIcon user_agent={s.user_agent} />
                </div>
                <div>
                  <div className="d-flex align-items-center gap-2">
                    <span className="fw-medium">{detectDevice(s.user_agent, t)}</span>
                    {isCurrentSession(s.user_agent) && <Badge color="success" pill>{t('common.current')}</Badge>}
                  </div>
                  <small className="text-muted">{detectBrowser(s.user_agent, t)} · {detectOS(s.user_agent, t)}</small><br />
                  <small className="text-muted">{s.ip} · {s.last_used_at}</small>
                </div>
              </div>
              <Button color="light" size="sm" outline className="text-danger" onClick={() => revokeSession(s.id)}>
                {t('common.revoke')}
              </Button>
            </div>
          ))}
        </CardBody>
      </Card>
    </TabPane>
  );
}

export default SessionsTab;
